export enum UserType {
	FREELANCE = 'freelance',
	COMPANY = 'company',
}
